/**
 * @function isDebug
 * @desc Checks to see if browser is in debug mode.
 *
 * @param {object}
 * @returns {Boolean}
 */

// Future Devs: uncomment for your debugging conveniance.  Make sure to re-comment once done.
// window.isDebugMode = true;

/**
 * Check to see if console logging is enabled.
 *
 * We use window.log so that we can have optional logging and avoid linting errors. The object is
 * set up in our template in Raven Nest.
 *
 * Available window.log methods are:
 * window.log.info()
 * window.log.error()
 * window.log.trace()
 * @return {bool} True if debugging is enabled.
 */

export default (): boolean => !!(window.isDebugMode && window.log != null);
